enum StoreActions {
  SET_NOTIFICATION = 'NOTIFICATION/SET_NOTIFICATION',
  CLOSE_NOTIFICATION = 'NOTIFICATION/CLOSE_NOTIFICATION',
  REMOVE_NOTIFICATION = 'NOTIFICATION/REMOVE_NOTIFICATION',
}

export const ActionTypes_Notifications = {
  StoreActions,
}
